if (!customElements.get('collection-tabs-separate')) {
  class CollectionTabsSeparate extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('[CollectionTabsSeparate] connected');

      this.target = this.dataset.target;
      this.slider = document.getElementById(this.target);

      if (!this.slider) {
        console.warn('[CollectionTabsSeparate] No slider found for:', this.target);
        return;
      }

      // Bottoni esterni (collegati via data-target)
      this.buttons = Array.from(document.querySelectorAll(`[data-tabs-target="${this.target}"] .collection-tabs-separate__list-link`));

      if (!this.buttons.length) {
        console.warn('[CollectionTabsSeparate] No buttons found for:', this.target);
        return;
      }

      // Etichette personalizzate
      this.buttons.forEach((button) => {
        const handle = button.dataset.collection;
        const labelEl = this.slider.querySelector(`[data-collection="${handle}"][data-tab-label]`);
        const label = labelEl?.dataset.tabLabel;
        if (label) button.innerText = label;
      });

      // Attiva primo
      const defaultButton = this.buttons[0];
      if (defaultButton) {
        defaultButton.classList.add('active');
        this.toggleCollection(defaultButton.dataset.collection, true);
      }

      // Click
      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const handle = button.dataset.collection;
          this.buttons.forEach(el => el.classList.remove('active'));
          button.classList.add('active');
          if (handle) this.toggleCollection(handle);
        });
      });

      // Modalità Shopify
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.buttons.indexOf(event.target);
          this.buttons[index]?.dispatchEvent(new Event('click'));
        });
      }
    }

    toggleCollection(handle, firstInit = false) {
      console.log('[CollectionTabsSeparate] toggleCollection', handle);

      const flkty = Flickity.data(this.slider);
      const all = this.slider.querySelectorAll('.columns');
      const active = this.slider.querySelectorAll(`[data-collection="${handle}"]`);
      const inactive = Array.from(all).filter(el => el.dataset.collection !== handle);

      inactive.forEach((el) => {
        el.classList.remove('carousel__slide');
        el.style.display = 'none';
      });

      active.forEach((el) => {
        el.classList.add('carousel__slide');
        el.style.display = 'flex';
        el.style.removeProperty('width');
      });

      if (flkty) {
        flkty.insert(active);
        flkty.reloadCells();
        flkty.select(0);
      } else if (firstInit) {
        new Flickity(this.slider, {
          cellSelector: '.carousel__slide',
          wrapAround: false,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
          groupCells: 1,
          selectedAttraction: 0.015,
          friction: 0.25
        });
      }
    }
  }

  customElements.define('collection-tabs-separate', CollectionTabsSeparate);
}